// Layout.js
import React, {useEffect, useState} from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {  useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";
import AuthService from "../services/AuthService";

const Layout = ({ children, hideHeader, hasPermission }) => {
    
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [settings, setSettings] = useState({});

    const getSettings = async () => {
        try {
            const response = await ApiService.request({
                method: "GET",
                url: "/public-settings",
            });
            if (response.data.status) {
                setSettings(response.data.data);
                // Apply theme colors
                if (response.data.data.theme_color) {
                    document.documentElement.style.setProperty('--kt-primary', response.data.data.theme_color);
                }
                if (response.data.data.secondary_color) {
                    document.documentElement.style.setProperty('--kt-secondary', response.data.data.secondary_color);
                }
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };

    const getNotifications = async () => {
        try {
            const user = AuthService.getCurrentUser();
            if (!user) {
                return; // Do not call notifications API if user is not logged in
            }
            const isCustomer = user.role === 'customer';
            const url = isCustomer
                ? "customer/notifications?is_read=false&per_page=5"
                : "admin/notifications?is_read=false&per_page=5";

            const response = await ApiService.request({
                method: "GET",
                url: url,
            });
            const data = response.data;
            if (data.status) {
                setNotifications(data.data.notifications || []);
                setUnreadCount(data.data.unread_count || 0);
            } else {
                console.log('Notifications not available:', data.message);
            }
        } catch (error) {
            console.log('Error fetching notifications:', error);
        }
    };
        
    useEffect(() => {
        if (!hasPermission) {
            toast.error("You don't have permssion to access this!");
            navigate(-1); 
        }
        getSettings();
        getNotifications();
    }, [navigate, hasPermission]);

    return (
        <div className="d-flex flex-column flex-root app-root" id='kt_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {/* Conditionally render the header based on the hideHeader prop */}
            {!hideHeader && (
                 <div>
                    <Header notifications={notifications} unreadCount={unreadCount} getNotifications={getNotifications} setNotifications={setNotifications} settings={settings} />
                    <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                        <Sidebar notifications={notifications} settings={settings} />
                        {children} {/* Render child components here */}
                    </div>

                </div>
            )}
            {hideHeader && (
                <main>
                    {children} 
                </main>
            )}
           
            </div>
        </div>
    );
};

export default Layout;
